// extracted by mini-css-extract-plugin
export default {"container":"ScoresManagement_container__swGz7","scoresContainer":"ScoresManagement_scoresContainer__bNygI","linkScores":"ScoresManagement_linkScores__zEYHz"};